import React from 'react';
import { Text } from 'react-native';

// Web-compatible icon component that mimics react-native-vector-icons/Ionicons
interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: any;
}

// Comprehensive icon mapping for all icons used in the SGA mobile app
const iconMap: { [key: string]: string } = {
  // Navigation - Home
  'home': '🏠',
  'home-outline': '🏠',

  // Time & Clock
  'time': '⏰',
  'time-outline': '⏰',
  'clock': '🕐',

  // Calendar & Schedule
  'calendar': '📅',
  'calendar-outline': '📅',

  // Classes tab
  'body': '🤸',
  'body-outline': '🤸',

  // User & People
  'person': '👤',
  'person-outline': '👤',
  'person-circle': '👤',
  'person-circle-outline': '👤',
  'people': '👥',
  'people-outline': '👥',

  // Documents
  'document-text': '📄',
  'document-text-outline': '📄',

  // Navigation arrows & chevrons
  'arrow-back': '←',
  'arrow-forward': '→',
  'chevron-forward': '›',
  'chevron-forward-outline': '›',
  'chevron-back': '‹',
  'chevron-back-outline': '‹',
  'chevron-down': '∨',
  'chevron-down-outline': '∨',
  'chevron-up': '∧',
  'chevron-up-outline': '∧',

  // Actions - Add/Remove
  'add': '+',
  'add-outline': '+',
  'add-circle': '⊕',
  'add-circle-outline': '⊕',
  'close': '✕',
  'close-outline': '✕',
  'close-circle': '⊗',
  'close-circle-outline': '⊗',

  // Login/Logout
  'log-in': '→',
  'log-in-outline': '→',
  'log-out': '🚪',
  'log-out-outline': '🚪',

  // Status & Info
  'checkmark': '✓',
  'checkmark-outline': '✓',
  'checkmark-circle': '✓',
  'checkmark-circle-outline': '✓',
  'information-circle': 'ⓘ',
  'information-circle-outline': 'ⓘ',
  'alert-circle': '⚠',
  'alert-circle-outline': '⚠',
  'help-circle': '?',
  'help-circle-outline': '?',
  'warning': '⚠',
  'warning-outline': '⚠',

  // Settings & Tools
  'settings': '⚙',
  'settings-outline': '⚙',
  'menu': '☰',
  'menu-outline': '☰',

  // Media Controls
  'play': '▶',
  'play-outline': '▶',
  'play-circle': '▶',
  'play-circle-outline': '▶',
  'stop': '■',
  'stop-outline': '■',
  'stop-circle': '■',
  'stop-circle-outline': '■',
  'pause': '⏸',
  'pause-outline': '⏸',

  // Communication
  'call': '📞',
  'call-outline': '📞',
  'mail': '✉',
  'mail-outline': '✉',

  // Location
  'location': '📍',
  'location-outline': '📍',

  // Work & Business
  'briefcase': '💼',
  'briefcase-outline': '💼',

  // Device
  'phone-portrait': '📱',
  'phone-portrait-outline': '📱',

  // Favorites
  'heart': '❤',
  'heart-outline': '♡',
  'star': '★',
  'star-outline': '☆',

  // Generic
  'circle': '●',
  'circle-outline': '○',
  'ellipse': '●',

  // Eye (for password visibility)
  'eye': '👁',
  'eye-outline': '👁',
  'eye-off': '🙈',
  'eye-off-outline': '🙈',

  // Refresh/Reload
  'refresh': '↻',
  'refresh-outline': '↻',
  'reload': '↻',
  'reload-outline': '↻',

  // Search
  'search': '🔍',
  'search-outline': '🔍',

  // Notifications
  'notifications': '🔔',
  'notifications-outline': '🔔',

  // Trash/Delete
  'trash': '🗑',
  'trash-outline': '🗑',

  // Edit
  'create': '✏',
  'create-outline': '✏',
  'pencil': '✏',

  // Share
  'share': '↗',
  'share-outline': '↗',

  // Download/Upload
  'download': '↓',
  'download-outline': '↓',
  'cloud-download': '☁↓',
  'cloud-download-outline': '☁↓',

  // Send
  'send': '➤',
  'send-outline': '➤',

  // Business/Building
  'business': '🏢',
  'business-outline': '🏢',

  // Repeat/Recurring
  'repeat': '↻',
  'repeat-outline': '↻',

  // Globe/Web
  'globe': '🌐',
  'globe-outline': '🌐',

  // Bulb (tips)
  'bulb': '💡',
  'bulb-outline': '💡',
};

const Icon: React.FC<IconProps> = ({ name, size = 24, color = '#000', style }) => {
  const icon = iconMap[name] || '•';

  return (
    <Text
      style={[
        {
          fontSize: size,
          color: color,
          lineHeight: size * 1.2,
          textAlign: 'center',
        },
        style
      ]}
    >
      {icon}
    </Text>
  );
};

export default Icon;

// Export as Ionicons for compatibility with react-native-vector-icons import pattern
export const Ionicons = Icon;
